import React, { useState, useEffect } from 'react';
import ModelEngine from '../components/ModelEngine';

const ModelTest = () => {
  const [webglSupported, setWebglSupported] = useState(true);
  const [loading, setLoading] = useState(true);
  const [mountTime] = useState(new Date());

  useEffect(() => {
    // Check WebGL support
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    setWebglSupported(!!gl);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#000',
        color: '#fff'
      }}>
        <p>Initializing 3D viewer...</p>
      </div>
    );
  }

  if (!webglSupported) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: '#000',
        color: '#fff'
      }}>
        <h1>WebGL Not Supported</h1>
        <p>Your browser doesn't support WebGL which is required for 3D rendering.</p>
        <p>Try updating your browser or using Chrome/Firefox.</p>
        <div style={{ 
          marginTop: '20px',
          padding: '15px',
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '8px',
          textAlign: 'left'
        }}>
          <p><strong>Debug Information:</strong></p>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li>Page loaded at: {mountTime.toString()}</li>
            <li>Browser: {navigator.userAgent}</li>
            <li>Viewport: {window.innerWidth} × {window.innerHeight}</li>
            <li>Path: {window.location.pathname}</li>
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      position: 'relative',
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      backgroundColor: '#000'
    }}>
      <div style={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        color: '#fff',
        zIndex: 100,
        backgroundColor: 'rgba(0,0,0,0.7)',
        padding: '15px',
        borderRadius: '8px',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h3 style={{ margin: '0 0 10px 0' }}>3D Model Viewer</h3>
        <div style={{ marginBottom: '5px' }}>Status: <strong>Ready</strong></div>
        <div style={{ marginBottom: '5px' }}>Route: {window.location.pathname}</div>
        <div>React: {React.version}</div>
      </div>
      
      <ModelEngine />
    </div>
  );
};

export default ModelTest;